export default __webpack_public_path__ + "static/media/main-bg.924c22fc.jpg";